import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export interface MigrationChecklistStepProps {
  supportRequestSentMigration: boolean;
  onRequestMigrationSupport: () => Promise<void>;
  requestingSupport: boolean;
}

export function MigrationChecklistStep({
  supportRequestSentMigration,
  onRequestMigrationSupport,
  requestingSupport,
}: MigrationChecklistStepProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <p className="text-muted-foreground text-sm">
          {t("onboarding.migrationChecklistIntro")}
        </p>
        <ul className="list-disc list-inside space-y-2 text-sm text-muted-foreground">
          <li>{t("onboarding.migrationChecklist1")}</li>
          <li>{t("onboarding.migrationChecklist2")}</li>
          <li>{t("onboarding.migrationChecklist3")}</li>
        </ul>
        {supportRequestSentMigration ? (
          <p className="text-green-600 text-sm font-medium">
            {t("onboarding.supportRequestSentMigration")}
          </p>
        ) : (
          <Button
            type="button"
            onClick={onRequestMigrationSupport}
            disabled={requestingSupport}
          >
            {requestingSupport && (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            )}
            {requestingSupport
              ? t("onboarding.requestFiscaloSending")
              : t("onboarding.askFiscaloMigration")}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
